// extracted by mini-css-extract-plugin
export default {"wall":"Wall_wall__yUohG"};